import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/auth/config/notification`

export default {
  show() {
    return Client.get(resource)
  },
  update(payload) {
    return Client.post(resource, payload)
  },
  unbindTelegram(id) {
    return Client.put(`${Config.basePath}/user/unbind-account/${id}`)
  },
}
